import { jsx as _jsx } from "react/jsx-runtime";
import { Env, readFromEnv } from "@cinch-nx/environments";
import { simpleAnalyticsTrack } from "@cinch-nx/shared-analytics";
import { ConsentManagerBuilder } from "@segment/consent-manager";
import { useEffect, useState } from "react";
import CookieConsent from "./cookie-consent";
import { getCookieConsentPreferences } from "./utils";
const CookieConsentContainer = ({ count , setLoaded , setIsPreferencesModalOpen , isPreferencesModalOpen  })=>{
    /**
   * This block is here due to LAN-1478. A race condition in our integration
   * with the Segment ConsentManagerBuilder component is causing fragility in
   * the rendering of the cookie banner. This code changes the React key after
   * a slight delay to force the component to remount, causing a re-render,
   * which reliably displays the cookie banner.
   */ const [consentBuilderLoaded, setConsentBuilderLoaded] = useState(false);
    useEffect(()=>{
        const isPreferenceCookieSet = getCookieConsentPreferences() ? true : false;
        if (!isPreferenceCookieSet) {
            setTimeout(()=>{
                var ref;
                if ((ref = window.analytics) === null || ref === void 0 ? void 0 : ref.load) window.analytics.initialized = undefined;
                setConsentBuilderLoaded(true);
            }, 600);
            simpleAnalyticsTrack("cookie_banner_shown");
        }
    }, []);
    return /*#__PURE__*/ _jsx(ConsentManagerBuilder, {
        writeKey: readFromEnv(Env.SegmentKey),
        children: (consentManager)=>/*#__PURE__*/ _jsx(CookieConsent, {
                consentManager: consentManager,
                setLoaded: setLoaded,
                setIsPreferencesModalOpen: setIsPreferencesModalOpen,
                isPreferencesModalOpen: isPreferencesModalOpen,
                count: count
            })
    }, `cmbLoaded-${consentBuilderLoaded}`);
};
export default CookieConsentContainer;
